
const topIntroPin = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    const secIntro = document.getElementById('jsSecIntro');
    const pinWrap = secIntro.querySelector('.js-pin-wrap');
    const pinArea = pinWrap.querySelector('.js-pin-area');
    const imgBox = pinWrap.querySelector('.js-img-box');
    const logoBox = pinWrap.querySelector('.js-logo-box');
    const copyWrap = secIntro.querySelector('.js-copy-wrap');


    // pin
    {
      let to = gsap.to(pinArea, {
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: pinArea,
          start: '50% 50%',
          endTrigger: secIntro,
          end: 'bottom bottom',
          pin: true,
          // markers: true
        }
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    }


    // zoom
    {
      let to = gsap.to(imgBox, {
        width: "100vw",
        height: "100vh",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: pinArea,
          start: '50% 50%',
          endTrigger: copyWrap,
          end: '0% 50%',
          scrub: 1,
          // onEnter: () => console.log("onEnter"),
          onLeave: () => imgBox.classList.add('act-ful'),
          onEnterBack: () => imgBox.classList.remove('act-ful'),
          // onLeaveBack: () => console.log("onLeaveBack"),
          // markers: true
        }
      })

      let to2 = gsap.to(logoBox, {
        y: '-35vh',
        rotationX: '90deg',
        autoAlpha: 0,
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: pinArea,
          start: '50% 50%',
          endTrigger: copyWrap,
          end: '0% 50%',
          scrub: 1,
          // markers: true
        }
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          to2.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    }



  }
})();
export default topIntroPin;